export default __webpack_public_path__ + "65fc15e20b69646b436e735b26b7ad20.png";